import { LogOut } from 'lucide-react';
import { Button } from '@viana-demos/ui';
import { useAuth } from '../auth/useAuth';

export function UserMenu() {
  const { name, email, logout } = useAuth();

  return (
    <div className="flex items-center gap-3">
      <div className="hidden text-right sm:block">
        <div className="text-sm font-medium text-slate-700">{name ?? email ?? 'Signed in'}</div>
        <div className="text-xs text-viana-muted">superadmin</div>
      </div>
      <Button variant="ghost" onClick={logout} aria-label="Sign out">
        <LogOut className="h-4 w-4" aria-hidden />
      </Button>
    </div>
  );
}
